import {
  getAdminWorkflow,
  getGenericWorkflowStatus,
  getUserWorkflows,
  getWorkflowById,
  getWorkflowStepNameByWorkflowStepId,
  getWorkflowStepsByGenericStepId,
  getWorkflows,
} from "../services/apiWorkflows";
import { hasAllQueryValues, hasQueryValue, useMappedQuery } from "./queryUtils";

export function useWorkflow() {
  return useMappedQuery({
    queryKey: ["workflows"],
    queryFn: getWorkflows,
    dataKey: "workflows",
  });
}

export function useWorkflowById(id, board_id) {
  return useMappedQuery({
    queryKey: ["workflow", board_id],
    queryFn: () => getWorkflowById(id, board_id),
    enabled: hasQueryValue(id),
  });
}

export function useAdminWorkflow() {
  return useMappedQuery({
    queryKey: ["adminWorkflow"],
    queryFn: getAdminWorkflow,
    dataKey: "adminWorkflows",
  });
}

export function useUserWorkflowList() {
  return useMappedQuery({
    queryKey: ["userWorkflowList"],
    queryFn: getUserWorkflows,
    dataKey: "userWorkflows",
  });
}

export function useGenericWorkflowStatus() {
  return useMappedQuery({
    queryKey: ["getGenericWorkflowStatus"],
    queryFn: getGenericWorkflowStatus,
    dataKey: "genericWorkflowStatus",
  });
}

export function useWorkflowStepNameByWorkflowStepId(
  workflow_step_id,
  board_id
) {
  return useMappedQuery({
    queryKey: ["workflow_step_name", workflow_step_id, board_id],
    queryFn: () =>
      getWorkflowStepNameByWorkflowStepId(workflow_step_id, board_id),
    enabled: hasAllQueryValues(workflow_step_id, board_id),
    dataKey: "workflowStepName",
  });
}

export function useWorkflowStepsbyBoardAndGenericStepId(boardId, genericStepId) {
  return useMappedQuery({
    queryKey: ["mapped_workflow_steps", boardId, genericStepId],
    queryFn: () => getWorkflowStepsByGenericStepId(boardId, genericStepId),
    enabled: hasAllQueryValues(genericStepId, boardId),
    dataKey: "workflowSteps",
  });
}
